import { render, staticRenderFns } from "./VulnSourceGitHubAdvisories.vue?vue&type=template&id=16192ae2&"
import script from "./VulnSourceGitHubAdvisories.vue?vue&type=script&lang=js&"
export * from "./VulnSourceGitHubAdvisories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16192ae2')) {
      api.createRecord('16192ae2', component.options)
    } else {
      api.reload('16192ae2', component.options)
    }
    module.hot.accept("./VulnSourceGitHubAdvisories.vue?vue&type=template&id=16192ae2&", function () {
      api.rerender('16192ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/vuln-sources/VulnSourceGitHubAdvisories.vue"
export default component.exports